import React from "react";
import Faq from "../Components/Other/Faq";

const FaqPage = () => {
  return <Faq />;
};

export default FaqPage;
